export const FETCH_TRANSFER_STOCK_LOCATIONS_PENDING = "FETCH_TRANSFER_STOCK_LOCATIONS_PENDING";
export const FETCH_TRANSFER_STOCK_LOCATIONS_REJECTED = "FETCH_TRANSFER_STOCK_LOCATIONS_REJECTED";
export const FETCH_TRANSFER_STOCK_LOCATIONS_FULFILLED = "FETCH_TRANSFER_STOCK_LOCATIONS_FULFILLED";


// WEBPACK FOOTER //
// ./src/constants/transferStockLocations.js